import Content from "./Content";
import ContentFactory from "./ContentFactory";

/**
* NPCContent.js
* 
* Created on 7-nov-2013, 11:49:43
*
* @author Ivo Swartjes for Ranj
**/
export default class NPCContent extends Content {
    constructor(languagePack, contentID, npcID, name, email, nickname, role, description, image, label) {

        super(NPCContent.NAME, NPCContent.TYPE, label, languagePack, contentID);

        this.setNpcID(npcID);
        this.setName(name);
        this.setEmail(email);
        this.setNickname(nickname);
        this.setRole(role);
        this.setDescription(description);
        this.setImage(image);

    }

    remove() {
        this.removeLanguagePackText(NPCContent.NPCID_LABEL);
        this.removeLanguagePackText(NPCContent.NAME_LABEL);
        this.removeLanguagePackText(NPCContent.EMAIL_LABEL);
        this.removeLanguagePackText(NPCContent.NICKNAME_LABEL);
        this.removeLanguagePackText(NPCContent.ROLE_LABEL);
        this.removeLanguagePackText(NPCContent.DESCRIPTION_LABEL);
        this.removeLanguagePackText(NPCContent.IMAGE_LABEL);

        super.remove();
    }

    clone() {
        const clone = ContentFactory.getContent(NPCContent.TYPE, this._languagePack);

        clone.setNpcID(this.getNpcID());
        clone.setName(this.getName());
        clone.setEmail(this.getEmail());
        clone.setNickname(this.getNickname());
        clone.setRole(this.getRole());
        clone.setDescription(this.getDescription());
        clone.setImage(this.getImage());

        return clone;
    }

    getNpcID() {
        return this.getLanguagePackText(NPCContent.NPCID_LABEL);
    }

    setNpcID(value) {
        this.setLanguagePackText(NPCContent.NPCID_LABEL, value);
    }

    getName() {
        return this.getLanguagePackText(NPCContent.NAME_LABEL);
    }

    setName(value) {
        this.setLanguagePackText(NPCContent.NAME_LABEL, value);
    }

    getEmail() {
        return this.getLanguagePackText(NPCContent.EMAIL_LABEL);
    }

    setEmail(value) {
        this.setLanguagePackText(NPCContent.EMAIL_LABEL, value);
    }

    getNickname() {
        return this.getLanguagePackText(NPCContent.NICKNAME_LABEL);
    }

    setNickname(value) {
        this.setLanguagePackText(NPCContent.NICKNAME_LABEL, value);
    }

    getRole() {
        return this.getLanguagePackText(NPCContent.ROLE_LABEL);
    }

    setRole(value) {
        this.setLanguagePackText(NPCContent.ROLE_LABEL, value);
    }

    getDescription() {
        return this.getLanguagePackText(NPCContent.DESCRIPTION_LABEL);
    }

    setDescription(value) {
        this.setLanguagePackText(NPCContent.DESCRIPTION_LABEL, value);
    }

    getImage() {
        return this.getLanguagePackText(NPCContent.IMAGE_LABEL);
    }

    setImage(value) {
        this.setLanguagePackText(NPCContent.IMAGE_LABEL, value);
    }

    convertToObject() {
        return this.getObject([]);
    }
}

NPCContent.NAME = "NPC";
NPCContent.TYPE = "engNPCContent";

NPCContent.NPCID_LABEL = "npcID";
NPCContent.NAME_LABEL = "name";
NPCContent.EMAIL_LABEL = "email";
NPCContent.NICKNAME_LABEL = "nickname";
NPCContent.ROLE_LABEL = "role";
NPCContent.DESCRIPTION_LABEL = "description";
NPCContent.IMAGE_LABEL = "image";

